import { useEffect, useState } from 'react';
import { UserPlus, Store, ShoppingCart, Smartphone, PlayCircle } from 'lucide-react';
import { api } from '../lib/api';

const STEPS = [
  { icon: UserPlus, title: '1. Inscris-toi', text: 'Crée ton compte Acheteur ou Vendeur avec ton e-mail ou ton numéro de téléphone, ou avec Google.' },
  { icon: Store, title: '2. Vends : boutique + produits + live', text: 'Le vendeur crée sa boutique, ajoute ses produits (photos, prix, stock) et peut lancer des enchères en direct.' },
  { icon: ShoppingCart, title: '3. Achète en boutique ou en live', text: 'Ajoute au panier des articles de plusieurs vendeurs, ou enchéris en un clic pendant un live.' },
  { icon: Smartphone, title: '4. Paie par Wave ou Orange Money', text: 'Tu paies directement le vendeur, tu confirmes « J\'ai payé », il te livre. Note-le ensuite.' },
];

const isFile = (u) => /\.(mp4|webm)(\?|$)/i.test(u);
const embed = (url) => {
  if (!url) return '';
  if (url.includes('/embed/')) return url;
  const y = url.match(/(?:youtu\.be\/|youtube\.com\/watch\?v=)([\w-]+)/);
  if (y) return `https://www.youtube.com/embed/${y[1]}`;
  const tv = url.match(/tiktok\.com\/@[\w.-]+\/video\/(\d+)/);
  if (tv) return `https://www.tiktok.com/embed/v2/${tv[1]}`;
  return url;
};

export const HowItWorks = () => {
  const [video, setVideo] = useState('/guide.mp4');
  useEffect(() => { api.get('/settings/public').then(({ data }) => setVideo(data.demo_video_url || '/guide.mp4')).catch(() => {}); }, []);
  useEffect(() => { if (window.location.hash === '#how-it-works') setTimeout(() => document.getElementById('how-it-works')?.scrollIntoView({ behavior: 'smooth' }), 300); }, []);
  return (
    <section id="how-it-works" className="w-full max-w-7xl mx-auto px-4 sm:px-6 pb-16 scroll-mt-24" data-testid="how-it-works">
      <div className="grid lg:grid-cols-[1.1fr_1fr] gap-8 items-center">
        <div>
          <div className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-sky-300"><PlayCircle className="h-4 w-4" />Comment ça marche</div>
          <h2 className="mt-2 font-display text-2xl sm:text-3xl font-bold">S'inscrire, vendre et acheter : le guide</h2>
          <div className="mt-6 space-y-4">
            {STEPS.map(({ icon: Icon, title, text }, i) => (
              <div key={title} className="flex gap-4 card-elev rounded-2xl p-4 reveal" data-testid={`how-step-${i + 1}`}>
                <span className="shrink-0 h-11 w-11 rounded-xl btn-brand grid place-items-center text-white"><Icon className="h-5 w-5" /></span>
                <div>
                  <div className="font-bold">{title}</div>
                  <div className="text-sm text-slate-400 mt-0.5">{text}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="relative hero-ring">
          <div className="aspect-video rounded-3xl overflow-hidden border border-white/10 shadow-2xl shadow-sky-900/40 bg-slate-900" data-testid="demo-video">
            {video && isFile(video) ? (
              <video data-testid="demo-video-player" poster="/og-image.png" controls playsInline preload="metadata" className="w-full h-full object-cover">
                <source src={video} type={video.endsWith('.webm') ? 'video/webm' : 'video/mp4'} />
              </video>
            ) : video ? (
              <iframe src={embed(video)} title="Comment ça marche" className="w-full h-full" allow="autoplay; encrypted-media; picture-in-picture" allowFullScreen />
            ) : (
              <div className="w-full h-full grid place-items-center text-center p-6">
                <div>
                  <div className="mx-auto h-16 w-16 rounded-full btn-brand grid place-items-center text-white"><PlayCircle className="h-8 w-8" /></div>
                  <div className="mt-4 font-display font-bold text-lg">Vidéo guide</div>
                  <div className="text-sm text-slate-400 mt-1">Bientôt disponible — en attendant, suivez les étapes ci-contre.</div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};
